import { Component } from '@angular/core';
import { FeatureService } from '../../services/feature.service';

@Component({
	selector: 'app-reset-wrapper',
	templateUrl: './reset-wrapper.component.html',
	styleUrl: './reset-wrapper.component.css'
})
export class ResetWrapperComponent {

	constructor(
		private featureService: FeatureService
	) { }

	isFeatureEnabled(feature: string): boolean {
		return this.featureService.isFeatureEnabled(feature);
	}
}
